import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/contactForm/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/gridItem/GridItem.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/gridSection/GridSection.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/page.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/contactSection/ContactSection.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/footer/Footer.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/organicGrowth/OrganicGrowthPlane.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sphereWave/SphereWave.tsx");
